module.exports = __webpack_public_path__ + "static/media/Quicksand_Book.dd2da1d8.otf";